export default __webpack_public_path__ + "static/sshepherd-d11d7375e4cc7dbac72a696504f1bd89.jpg";